import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideUserDelete: React.FC = () => {
  return (
    <GuidePageLayout
      title="ユーザーを削除する"
      description="不要になったユーザーアカウントを削除します。"
      breadcrumbs={[{ label: 'ユーザー管理', path: '/guide/user/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者'],
            ['ログイン状態', 'ログイン済みであること'],
            ['対象ユーザー', '存在すること'],
            ['制限', '自分自身は削除できない'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: 'ユーザー管理画面を開く' },
            { label: 'ユーザー一覧から対象ユーザーを選択する' },
            {
              label: '詳細画面のフッターにある「削除」ボタンを押下する',
              content: (
                <GuideMockContainer label="フッターボタン（詳細表示時）">
                  <GuideMockButton label="削除" color="error" startIcon={<DeleteIcon />} />
                </GuideMockContainer>
              ),
            },
            {
              label: '削除確認ダイアログで対象ユーザーのユーザーIDを入力する',
            },
            { label: '「実行」ボタンを押下して削除を実行する' },
          ]}
        />
      </GuideSection>

      <GuideSection title="削除確認ダイアログ">
        <Stack spacing={1}>
          <GuideInfoBox type="warning">
            ダイアログ内に「この操作は取り消せません。削除されたユーザーは復元できません。」という警告が表示されます。
          </GuideInfoBox>
          <GuideInfoBox>
            誤操作防止のためユーザーIDの入力が求められます。正確に入力しないと「実行」ボタンが活性化しません。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox type="warning">
            削除は取り消せません。削除前に必ず確認してください。
          </GuideInfoBox>
          <GuideInfoBox type="warning">削除されたユーザーはログインできなくなります。</GuideInfoBox>
          <GuideInfoBox>
            他機能で削除済みユーザーを参照している場合は「削除済みユーザー」として表示されます。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideUserDelete;
